import $ from "jquery"

$(function(){
    //上部画像の設定
    $('.js_gallery').slick({
        infinite: false, //スライドをループさせるかどうか。初期値はtrue。
        fade: true, //フェードの有効化
        arrows: true,//左右の矢印あり
        prevArrow: '<div class="Arrow"></div>',//矢印部分PreviewのHTMLを変更
        nextArrow: '<div class="Arrow Right"></div>',//矢印部分NextのHTMLを変更
        asNavFor: '.js_choice-btn', //連動させるサムネイルのクラス名
    });

    //選択画像の設定
    $('.js_choice-btn').slick({
        infinite: false, //スライドをループさせるかどうか。初期値はtrue。
        slidesToShow: 1, //表示させるスライドの数
        focusOnSelect: true, //フォーカスの有効化
        prevArrow: '<div class="Arrow"></div>',//矢印部分PreviewのHTMLを変更
        nextArrow: '<div class="Arrow Right"></div>',//矢印部分NextのHTMLを変更
        asNavFor: '.js_gallery', //連動させるスライドショーのクラス名
    });
})


$(function () {
    $('#js-slider-2').slick({
        arrows: true, // 前・次のボタンを表示する
        dots: true, // ドットナビゲーションを表示する
        appendDots: $('.dots-2'), // ドットナビゲーションの生成位置を変更
        speed: 1000, // スライドさせるスピード（ミリ秒）
        slidesToShow: 1, // 表示させるスライド数
        centerMode: true, // slidesToShowが奇数のとき、現在のスライドを中央に表示する
        variableWidth: true, // スライド幅の自動計算を無効化
    });
});

$(function () {
    var num = 0;
    $('.js-slider-2').each(function () {
        num++;
        $(this).slick({
            arrows: true, // 前・次のボタンを表示する
            dots: true, // ドットナビゲーションを表示する
            appendDots: $('.dots-num-'+ num), // ドットナビゲーションの生成位置を変更
            speed: 1000, // スライドさせるスピード（ミリ秒）
            slidesToShow: 1, // 表示させるスライド数
            centerMode: true, // slidesToShowが奇数のとき、現在のスライドを中央に表示する
            variableWidth: true, // スライド幅の自動計算を無効化
        })
    });
});
